"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = exports.verifyValue = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DATE_REGEX = /^\d{4}-[01][0-9]-[0-3][0-9]$/,
    NUMBER_REGEX = /^(-(?=[1-9]|(0[.]0*[1-9]+)))?\d*[.]?\d+/;
var PARENS_REGEX = /^([[(])(-?\d+),(-?\d+)([)\]])$/,
    COMPARE_REGEX = /^([><]=?)(\d+)$/;

var processArgs = function processArgs(num, op, val) {
  switch (op) {
    case ">":
      return num > val;

    case ">=":
      return num >= val;

    case "<":
      return num < val;

    case "<=":
      return num <= val;

    default:
      return true;
  }
};

var verifyNumber = function verifyNumber(num, verify) {
  if (!verify) return true;
  verify = verify.replace(/\s/g, "");
  var args = [];
  var hasParens = PARENS_REGEX.exec(verify);

  if (hasParens) {
    var _hasParens = _slicedToArray(hasParens, 5),
        open = _hasParens[1],
        min = _hasParens[2],
        max = _hasParens[3],
        close = _hasParens[4];

    if (open === "(") {
      args.push([">", +min]);
    } else if (open === "[") {
      args.push([">=", +min]);
    }

    if (close === ")") {
      args.push(["<", +max]);
    } else if (close === "]") {
      args.push(["<=", +max]);
    }
  }

  var hasCompare = COMPARE_REGEX.exec(verify);

  if (hasCompare) {
    var _hasCompare = _slicedToArray(hasCompare, 3),
        op = _hasCompare[1],
        value = _hasCompare[2];

    args.push([op, +value]);
  }

  return args.reduce(function (a, c) {
    return a && processArgs.apply(void 0, [+num].concat(_toConsumableArray(c)));
  }, true);
};

var verifyValue = function verifyValue(value, type) {
  var verify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  switch (type) {
    case "number":
      {
        return NUMBER_REGEX.test(value) && verifyNumber(value, verify);
      }

    case "date":
      {
        var regex = typeof verify === "string" ? new RegExp(verify) : DATE_REGEX;
        return regex.test(value);
      }

    default:
      {
        var _regex = typeof verify === "string" ? new RegExp(verify) : false;

        return !_regex || _regex.test(value);
      }
  }
};

exports.verifyValue = verifyValue;

var hasValue = function hasValue(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "string" && !value.length) return false;
  if (Array.isArray(value)) return value.reduce(function (a, c) {
    return a || hasValue(c);
  }, false);
  if (typeof value === "number" && isNaN(value)) return false;
  if (_typeof(value) === "object") return Object.values(value).reduce(function (a, c) {
    return a || hasValue(c);
  }, false);
  return true;
};

exports.hasValue = hasValue;